import { makeStyles } from 'tss-react/mui';

import { TokenSize } from '@constants/common/ui.constants';

const useStyles = makeStyles<{ size: TokenSize }>()((theme, { size }) => ({
  avatar: {
    borderRadius: theme.borderRadius.xxl,

    ...(size === TokenSize.ExtraSmall && {
      width: 12,
      minWidth: 12,
      height: 12,
    }),

    ...(size === TokenSize.Small && {
      width: 16,
      minWidth: 16,
      height: 16,
    }),

    ...(size === TokenSize.Medium && {
      width: 20,
      minWidth: 20,
      height: 20,
    }),

    ...(size === TokenSize.Large && {
      width: 24,
      minWidth: 24,
      height: 24,
    }),
  },
}));

export default useStyles;
